import { GridColDef } from '@mui/x-data-grid-pro';
import { Contact } from '@api/Trinium/Endpoints/Contact/types';

import styles from './DataGrid.Contacts.module.css';
import CheckboxCell from '@components/DataGrid/ColumnDefinitions/CheckboxCell';

export const contactsColumnDefinitions: GridColDef<Contact>[] = [
	{
		field: 'main',
		minWidth: 60,
		width: 60,
		headerName: 'Main',
		headerClassName: styles['grid-column-header'],
		sortable: false,
		disableReorder: true,
		renderCell: ({ row }) => (
			<CheckboxCell
				value={row.isMain}
				className={styles['check-cell']}
			/>
		)
	},
	{
		field: 'name',
		minWidth: 125,
		width: 125,
		headerName: 'Name',
		headerClassName: styles['grid-column-header'],
		sortable: false,
		disableReorder: true
	},
	{
		field: 'phone',
		minWidth: 120,
		width: 120,
		headerName: 'Phone',
		headerClassName: styles['grid-column-header'],
		sortable: false,
		disableReorder: true
	},
	{
		field: 'fax',
		minWidth: 120,
		width: 120,
		headerName: 'Fax',
		headerClassName: styles['grid-column-header'],
		sortable: false,
		disableReorder: true
	},
	{
		field: 'email',
		minWidth: 150,
		width: 150,
		headerName: 'Email',
		headerClassName: styles['grid-column-header'],
		sortable: false,
		disableReorder: true
	},
	{
		field: 'notes',
		minWidth: 180,
		flex: 1,
		headerName: 'Notes',
		headerClassName: styles['grid-column-header'],
		sortable: false,
		disableReorder: true
	}
];
